import React, { useState } from 'react';
import Translate from "../components/Translate";
import {silverInfoStyles} from "../utils/General";

const timeInputStyles = {
    container: {
        display: 'flex',
        flexDirection: 'column',
        gap: '6px',
        marginBottom: '20px',
    },
    label: {
        fontSize: '14px',
        color: '#A4ADC1',
        fontWeight: '500',
    },
    input: {
        padding: '12px 16px',
        fontSize: '16px',
        width: '100%',
        borderRadius: '10px',
        border: '1px solid #ddd',
        backgroundColor: '#fff',
        color: '#333',
        // boxShadow: '0 2px 5px rgba(0, 0, 0, 0.1)',
        outline: 'none',
        transition: 'all 0.3s ease-in-out',
    },
    inputFocus: {
        // borderColor: '#2B7BFF',
        boxShadow: '0 0 0 2px rgba(43, 123, 255, 0.2)',
    },
    inputError: {
        borderColor: '#ff4d4f',
        backgroundColor: '#fff1f0',
    }
};

const isValidTime = (value) => {
    const match = /^([01]\d|2[0-3]):([0-5]\d)$/.test(value);
    return match;
};

const TimeInput = ({ label, name, value, onChange }) => {
    const [isFocused, setIsFocused] = useState(false);
    const [hasError, setHasError] = useState(false);

    const handleBlur = () => {
        setIsFocused(false);
        setHasError(!isValidTime(value));
    };

    const handleInputChange = (e) => {
        const val = e.target.value;

        if (/^[0-9:]{0,5}$/.test(val)) {
            onChange(e);
        }
    };

    return (
        <div style={timeInputStyles.container}>
            <span style={{...silverInfoStyles.info, marginLeft: '0px'}}><Translate text={label} /></span>
            <input
                type="text"
                name={name}
                value={value}
                placeholder="HH:mm"
                onChange={handleInputChange}
                onFocus={() => setIsFocused(true)}
                onBlur={handleBlur}
                style={{
                    ...timeInputStyles.input,
                    ...(isFocused ? timeInputStyles.inputFocus : {}),
                    ...(hasError ? timeInputStyles.inputError : {}),
                }}
                maxLength={5}
            />
        </div>
    );
};

export default TimeInput;



// WEBPACK FOOTER //
// ./src/components-new/TimeInput.jsx